import { useEffect, useState } from 'react'
import FormDrawer from '../../common/form-drawer'
import usePayrollEssentials from 'hooks/usePayrollEssentials';
import { assignPayGroupEmployees, getPayGroupEmployees, getPayGroups } from 'store/entities/payroll/payrollSetup/action';
import { getAllEmployees } from 'store/entities/employees/action';
import iconSearch from "assets/images/icons/icon-search.svg";
import Spinner from 'components/__new/common/Spinner';
import { ReactComponent as Check } from "assets/images/icons/check.svg";

const PayGroupEmployeeAssignmentModal = ({toggleModal, selectedPayGroup, setCurrent, isQuickAssign}) => {
const [search, setSearch] = useState("");
const {dispatch, useSelector} = usePayrollEssentials()

const { allEmployees: {docs: allEmployees}, employeesLoading } = useSelector(state => state.entities.employees)
const { updatePayGroupEmployeesLoading: updateLoading, isPayGroupQuickAssignModalOpen } = useSelector(state => state.entities.payrollSetup)
const [selected, setSelected] = useState([]);

const filteredItems = allEmployees?.filter(item => !selectedPayGroup?.employee_ids?.includes(item?._id))?.filter(item => {
    if(search === "") {
        return true
    } else {
        // return item?.fullName?.toLowerCase()?.includes(search?.toLowerCase())
        const name = (item?.firstName?.toLowerCase() ?? "") + (item?.lastName?.toLowerCase() ?? "");
        return name?.includes(search?.toLowerCase())
    }
})
const unassignedStaff = allEmployees?.filter((item) => {
    return !item.disabled && !selectedPayGroup?.employee_ids?.includes(item?._id) && (item?.pay_group_id === null || item?.pay_group_id?.length < 1) 
})?.map((item) => item._id)

const toggleSelection = (id) => {
    if(selected?.includes(id)) {
        const newItems = selected?.filter((item) => item !== id)
        setSelected(newItems)
    } else {
        setSelected([...selected, id])
    }
}

const clearAndClose = () => {
    setSearch("")
    setSelected([])
    toggleModal()
    }

const onProceed = () => {
    const payload = {
        id: selectedPayGroup.id,
        employee_ids: selected
    }
    dispatch(assignPayGroupEmployees(payload))
    .then(() => {
        clearAndClose();
        if(isQuickAssign) {
            dispatch(getPayGroups({ "page": 1, "limit": 10 }))
        } else {
            setTimeout(() => {
                dispatch(getPayGroupEmployees({id: selectedPayGroup?.id}));
            }, 2000);
        }
        dispatch(getAllEmployees({page: 1}));
    })
}

useEffect(() => {
    dispatch(getAllEmployees({page: 1}))
    // eslint-disable-next-line
}, [])

    return (
            <FormDrawer display="center" size="lg" isOpen={isPayGroupQuickAssignModalOpen} setIsOpen={toggleModal}>
                {employeesLoading || updateLoading ? <Spinner message={updateLoading ? "Updating Employees" : "Fetching Employees"} />
                :
                <div className="p-7 w-full">
                        <div className="mb-5">
                            <p className="mb-1 font-semibold">Add New Employees</p>
                        </div>

                    <div className="my-7">
                        <div className="form-group-icon h-10 rounded-md border">
                            <label htmlFor="search">
                                <img src={iconSearch} alt="Search" className="form-group-icon-attach h-4" />
                            </label>
                            <input
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                                placeholder="Search employees"
                                className="w-full border h-full form-input-icon focus:ring-transparent"
                                style={{paddingLeft: "0",  outline: "none"}}
                            />
                        </div>

                        <div className="flex items-center justify-end pt-6">
                            <button onClick={() => setSelected(unassignedStaff)} className="text-ep-primary-600 mr-3">Select all</button>
                            <button onClick={() => setSelected([])} className="text-ep-primary-600">Deselect all</button>
                        </div>

                        <div style={{maxHeight: '300px'}} className="overflow-y-scroll modal-list-wrap mt-6">
                            {filteredItems?.map((item, index) => {
                                const isDeactivated = item?.disabled === true
                                const isAssigned = item?.pay_group_id && item?.pay_group_id?.length > 0
                                const isSelected = selected?.includes(item?._id)
                                return <div onClick={() => (isAssigned || isDeactivated) ? null : toggleSelection(item._id)} key={index}
                                            className={`flex items-start justify-between border rounded-md p-3.5 mb-5 cursor-pointer ${(isAssigned || isDeactivated) && "cursor-not-allowed bg-[#f9fafb]"} ${isSelected && "border-ep-primary-600"}`}>
                                        <div>
                                            <p className="capitalize mb-1 font-medium tracking-wide flex items-center">
                                                {item.firstName.toLowerCase()} {item.lastName.toLowerCase()}
                                                {isAssigned && !isDeactivated &&
                                                    <span className="text-[8px] rounded-lg bg-ep-primary-500 flex items-center text-white px-2 py-1 ml-2">
                                                        Employee added
                                                    </span>
                                                }
                                                {isDeactivated &&
                                                    <span className="text-[8px] rounded-lg bg-ep-danger flex items-center text-white px-2 py-1 ml-2">
                                                        Deactivated
                                                    </span>
                                                }
                                            </p>
                                            <p className="text-xs lt-gray mb-0">
                                                {item.jobTitle}
                                            </p>
                                        </div>
                                        <div className="flex items-center justify-center w-5 h-5 rounded-full border">
                                            {isSelected && <Check />}
                                        </div>
                                </div>
                            })}
                        </div>
                    </div>
                    <div className="w-full flex items-center mt-12">
                        <button disabled={selected?.length < 1 || updateLoading} onClick={onProceed} className="btn btn-md btn-ep-primary mr-4 lg:mr-6">
                            Add {selected?.length > 1 ? "Employees" : "Employee"}
                        </button>
                        <button onClick={clearAndClose} type='button' className="btn btn-md btn-transparent-primary">Close</button>
                    </div>
                </div>}
            </FormDrawer>
        )
}

export default PayGroupEmployeeAssignmentModal